import {RouterProvider} from 'react-router-dom';
import {QueryClientProvider} from '@tanstack/react-query';
import {ReactQueryDevtools} from '@tanstack/react-query-devtools';
import {ConfigProvider} from 'antd';
import zhCN from 'antd/locale/zh_CN';
import ErrorBoundary from '@components/common/ErrorBoundary';
import router from '@/router';
import {queryClient} from '@/utils/queryClient';
import {useInitUserInfo} from '@/hooks/useInitUserInfo';
import {usePrefetchHomeInfo} from '@/hooks/useHomeInfo';
import {useTheme} from '@/hooks/useTheme';
import {TrackingProvider} from '@/services/tracking/context';

const App: React.FC = () => {
    // 初始化主题
    useTheme();
    // 初始化用户信息
    useInitUserInfo();
    // 预取首页信息
    usePrefetchHomeInfo();

    return (
        <ErrorBoundary level="global">
            <ConfigProvider locale={zhCN}>
                <QueryClientProvider client={queryClient}>
                    <TrackingProvider>
                        <RouterProvider router={router} />
                    </TrackingProvider>
                    {/* React Query Devtools: Only visible in development mode */}
                    <ReactQueryDevtools initialIsOpen={false} />
                </QueryClientProvider>
            </ConfigProvider>
        </ErrorBoundary>
    );
};

export default App;
